import React from 'react';
import { inject, observer } from 'mobx-react';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import MoneyInput from '../ItemDetails/MoneyInput';
import QtyInput from '../ItemDetails/QtyInput';
import TitleInput from '../ItemDetails/TitleInput';
import ImageUploader from 'js/components/core/ImageUploader';
import { validatePrice } from 'js/services/Regex';
import defaultImg from '../../../../../../../public/images/new-upload.png'

@inject('page')
@observer
export default class ImageAndPrice extends React.Component {
  render() {
    const page = this.props.page;

    return (
      <>
        <h6 className='tw-font-semibold tw-mb-4'>Add item details</h6>

        <p>Item image</p>
        <ImageUploader style={{ textAlign: 'center', padding: '50px 0' }}
          className="file-uploader tw-bg-[url('/images/new-upload.png')]"
          image={page.primary_image_state ? page.primary_image : defaultImg} setError={page.setError} onUpload={page.onUpload} height="247px"
          innerRef={this.fileUpload} id="fileUpload">
        </ImageUploader>

        <span className="clearfix" style={{ clear: 'both' }}>&nbsp;</span>

        <span className="tw-font-medium">Item name</span><br />
        <TitleInput
          name="title"
          value={page.title}
          onChange={page.setTitle}
          required
        />

        <div className="tw-flex tw-gap-2 tw-w-full">
          <div className='tw-flex-1'>
            <span>Price</span><br />
            <MoneyInput
              name="price"
              type="number"
              value={page.price}
              onChange={page.setPrice}
              validate={validatePrice}
              required
            />
          </div>

          <div className='tw-flex-1'>
            <span>QTY</span><br />
            <QtyInput
              name="quantity"
              type="number"
              value={page.quantity}
              onChange={page.setQuantity}
              required
            />
          </div>
        </div>

        <ContinueButton flat disabled={!page.title.length && !page.price.length && !page.quantity.length} />
      </>
    );
  }
}
